import styled, { css } from "styled-components";
import { Table } from "components/bootstrap";
const StyledTable = styled(Table)(
  ({ theme }) => css`
    thead > tr > th {
      vertical-align: middle !important;
      max-width: 300px;
      white-space: nowrap;
      text-overflow: ellipsis;
      padding: ${theme.spacings.md} ${theme.spacings.sm} !important;
      background-color: ${theme.colors.table.head.background} !important;
    }
    tbody > tr > td {
      vertical-align: middle !important;
      max-width: 300px;
      padding: ${theme.spacings.md} ${theme.spacings.sm} !important;
      color: ${theme.colors.brand.tertiary};

      &:not(:last-child) {
        overflow-x: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  `
);
export default StyledTable;
